// removed by extract-text-webpack-plugin
module.exports = {"appMenuSticky":"src-components-main-__main-module___appMenuSticky","loader":"src-components-main-__main-module___loader","appMargin":"src-components-main-__main-module___appMargin"};


//////////////////
// WEBPACK FOOTER
// ./src/components/main/main.module.css
// module id = 400
// module chunks = 52